const hanlder = tracker => ({
  trackNewLogin: token => {

    const sessionData = {
      email: token.email,
      fullName: token.name
    }

    tracker().trackEvent("Login", sessionData)
  }
})

export default hanlder